export const STATUS_CODE = {
  unDownloaded: -1,
  init: 0,
  downloading: 1, //下载中，按钮显示【暂停】并展示【进度】
  prepareDownload: 8,
  pause: 2, //暂停，按钮显示【继续】
  resume: 3, //继续，按钮显示【暂停】并展示【进度】
  downloaded: 4, //下载完成，按钮显示【安装】
  canceled: 5, // 取消下载
  installing: 6, //安装中，按钮显示【安装中】
  installed: 7, // 安装完成，按钮显示【打开】
  start: 9,
};

export const statusMap = {
  [STATUS_CODE.init]: '安装',
  [STATUS_CODE.prepareDownload]: '安装',
  [STATUS_CODE.start]: '等待中',
  [STATUS_CODE.pause]: '继续',
  [STATUS_CODE.resume]: '暂停',
  [STATUS_CODE.downloaded]: '安装',
  [STATUS_CODE.installing]: '安装中',
  [STATUS_CODE.installed]: '打开',
};
